var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "money-bag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.601,
    height: 17.543,
    viewBox: "0 0 13.601 17.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M55.961,12.194a8.714,8.714,0,0,0-3.816-5.739.794.794,0,0,0,.167-.486v-.72a.8.8,0,0,0-.527-.742l.906-3.285A.371.371,0,0,0,52.137.8L50.281,1.962,49.628.24a.371.371,0,0,0-.694,0l-.642,1.723L46.435.8a.371.371,0,0,0-.553.416l.906,3.285a.8.8,0,0,0-.527.742v.724a.8.8,0,0,0,.171.486A8.644,8.644,0,0,0,42.6,12.194a3.564,3.564,0,0,0,.639,3.122c1.065,1.355,3.263,2.194,5.88,2.227h.3c2.617-.052,4.826-.891,5.88-2.227A3.564,3.564,0,0,0,55.961,12.194ZM48.28,2.838a.371.371,0,0,0,.511-.122.375.375,0,0,0,.031-.064l.457-1.233.453,1.218a.371.371,0,0,0,.542.186l1.448-.9-.694,2.517h-3.5l-.694-2.517Zm3.293,2.409,0,.011v.724a.059.059,0,0,1-.059.059H47.478a.37.37,0,0,0-.111,0h-.316a.059.059,0,0,1-.059-.059V5.248a.059.059,0,0,1,.059-.059h4.455a.059.059,0,0,1,.066.052A.063.063,0,0,1,51.573,5.248Zm3.156,9.611,0,.011c-.924,1.173-2.97,1.923-5.357,1.964h-.186c-2.38-.041-4.433-.791-5.357-1.964a2.851,2.851,0,0,1-.486-2.513c.609-2.729,2.153-4.808,4.136-5.569H51.1c1.979.78,3.523,2.862,4.132,5.569A2.855,2.855,0,0,1,54.729,14.859Z",
    transform: "translate(-42.475 0)",
    fill: "#41bf77"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(5.356 8.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M160.793,187.252a1.3,1.3,0,0,0-.557-.46,2.991,2.991,0,0,0-.609-.2v-1.114a2.021,2.021,0,0,1,.676.33.282.282,0,0,0,.391-.078l0,0a.286.286,0,0,0-.078-.394,2.41,2.41,0,0,0-.995-.431v-.742a.278.278,0,0,0-.557,0v.768a1.571,1.571,0,0,0-.627.26,1.028,1.028,0,0,0-.445.813.854.854,0,0,0,.13.457,1.2,1.2,0,0,0,.516.434,2.519,2.519,0,0,0,.427.149v1.233a2.091,2.091,0,0,1-.717-.371.29.29,0,0,0-.4.037.3.3,0,0,0,.045.4,2.6,2.6,0,0,0,1.065.535v.854a.278.278,0,0,0,.557,0V188.9a1.694,1.694,0,0,0,.835-.319,1.077,1.077,0,0,0,.479-.861A.9.9,0,0,0,160.793,187.252Zm-1.737-.776a1.3,1.3,0,0,1-.308-.149.538.538,0,0,1-.152-.145.271.271,0,0,1-.037-.156.442.442,0,0,1,.212-.349.948.948,0,0,1,.286-.137Zm1.043,1.667a1.114,1.114,0,0,1-.486.189v-1.14a1.815,1.815,0,0,1,.509.2.523.523,0,0,1,.167.167.315.315,0,0,1,.048.178A.5.5,0,0,1,160.1,188.143Z",
    transform: "translate(-157.886 -183.885)",
    fill: "#41bf77"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money_bag.d7a26acd9e0853b2c0f06c6955664d28.svg";
export { ForwardRef as ReactComponent };